import { useState } from "react";
import { Navigation } from "swiper/modules";
import { ZownForecast } from "./zownForecast";
import { PropertyCard } from "./propertyCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { ComparableSales } from "./comparableSales";
import { MortgageCalculatore } from "./MortgageCalculatore";
import type { ListingGraphs } from "../../interfaces/graphs";
import type { ListingDetailed } from "../../interfaces/listing";
import GrayArrowDownIcon from "../../assets/grayArrowDownIcon.svg";
import { convertToFormattedAmount } from "../../utils/convertAmount";
import type { ComparablesData } from "../../interfaces/comparablesInterface";
import PropertyAnalysisIcon from "../../assets/icons/propertyAnalysisIcon.svg";

import "swiper/css";
import "swiper/css/navigation";

interface AnalysisProps {
  listing: ListingDetailed | null;
  statistics?: ListingGraphs | null;
  comparableData?: ComparablesData | null;
}

const PropertyAnalysis = ({
  listing,
  statistics,
  comparableData,
}: AnalysisProps) => {
  const [isExpanded, setIsExpanded] = useState(true);
  return (
    <div className="border bg-white mt-10 border-[#D9D9D9] shadow-[0_2px_12.6px_0_rgba(0,0,0,0.25)] rounded-[30px] xl:py-[45px] py-[40px]">
      <div
        className="text-black font-semibold text-xl flex items-center justify-between w-full cursor-pointer xl:px-10 px-6"
        onClick={() => setIsExpanded((prevState) => !prevState)}
        onKeyDown={() => setIsExpanded((prevState) => !prevState)}
      >
        <div className="flex items-center gap-2">
          <img width={40} src={PropertyAnalysisIcon} alt="" />
          <span className="text-[#333] text-3xl">Analysis</span>
        </div>

        <img
          src={GrayArrowDownIcon}
          alt="Toggle Section"
          className={`transition-transform duration-300 ${
            isExpanded ? "rotate-180" : ""
          }`}
        />
      </div>
      <div
        id="analysis-content"
        className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
          isExpanded ? "max-h-auto" : "max-h-0"
        }`}
      >
        <div className="xl:px-10 px-6 mt-6">
          <hr className="h-px bg-[#F3F3F3] border-0 mb-6" />
          <MortgageCalculatore
            listingPrice={convertToFormattedAmount(
              listing?.listPrice
            ).toString()}
            mortgageRate={listing?.mortgageRate ?? ""}
            minDownPaymentNeeded={convertToFormattedAmount(
              listing?.minDownPaymentNeeded
            )}
          />
          {statistics?.zownForecast && (
            <hr className="h-px bg-[#F3F3F3] border-0 mt-14 mb-16" />
          )}
        </div>
        {statistics?.zownForecast && (
          <ZownForecast zownForecast={statistics?.zownForecast} />
        )}
        <div className="!mt-20">
          <div className="xl:px-10 px-6">
            <hr className="h-px bg-[#F3F3F3] border-0 mb-14" />
            {(comparableData?.statistics?.count ||
              comparableData?.statistics?.statistics?.soldPrice?.med ||
              comparableData?.statistics?.statistics?.daysOnMarket?.avg ||
              comparableData?.statistics?.statistics?.daysOnMarket
                ?.mostRecentSaleInDays) && (
              <ComparableSales
                numberComparableSales={comparableData?.statistics?.count}
                medianSalePrice={
                  comparableData?.statistics?.statistics?.soldPrice?.med
                }
                avgDom={
                  comparableData?.statistics?.statistics?.daysOnMarket?.avg
                }
                mostRecentSale={
                  comparableData?.statistics?.statistics?.daysOnMarket
                    ?.mostRecentSaleInDays
                }
              />
            )}
          </div>
          {comparableData?.comparables &&
            comparableData?.comparables?.length > 0 && (
              <div className="flex items-center space-x-6 mt-8 relative xl:px-10 px-6 w-full">
                <Swiper
                  className="w-full"
                  spaceBetween={20}
                  slidesPerView={3}
                  pagination={false}
                  loop={true}
                  modules={[Navigation]}
                  navigation={{
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                  }}
                  breakpoints={{
                    1540: {
                      slidesPerView: 3,
                    },
                    1280: {
                      slidesPerView: 2,
                    },
                    1080: {
                      slidesPerView: 1.4,
                    },
                  }}
                >
                  {comparableData?.comparables.map((property) => (
                    <SwiperSlide
                      className="p-2"
                      key={property.listingId}
                      style={{ width: "auto" }}
                    >
                      <PropertyCard property={property} />
                    </SwiperSlide>
                  ))}
                </Swiper>
                <div className="browse-listing-slider swiper-button-prev similar !mx-0" />
                <div className="browse-listing-slider swiper-button-next similar !mx-0" />
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export { PropertyAnalysis };
